(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["big-hero-video-image"] && !Shopify.designMode) return;
  try {
    
  // JavaScript removed as requested

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    initAccordions();
  });

  // Re-initialize accordions when Shopify section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.faq-accordion')) {
      initAccordions();
    }
  });

  function initAccordions() {
    const accordionItems = document.querySelectorAll('.faq-accordion__item');

    accordionItems.forEach((item) => {
      const button = item.querySelector('.faq-accordion__button');
      const content = item.querySelector('.faq-accordion__content');

      if (!button || !content) return;

      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        // Close all other items
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) {
            const otherButton = otherItem.querySelector('.faq-accordion__button');
            const otherContent = otherItem.querySelector('.faq-accordion__content');

            if (otherButton && otherContent) {
              otherButton.setAttribute('aria-expanded', 'false');
              otherContent.setAttribute('aria-hidden', 'true');
            }
          }
        });

        // Toggle current item
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexy-grid"] && !Shopify.designMode) return;
  try {
    
  // No additional JavaScript needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensilis-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  // Initialize menu items for animation
  const menuItems = document.querySelectorAll('.footer-menu-column ul li');
  menuItems.forEach((item, index) => {
    item.style.setProperty('--item-index', index + 1);
  });

  // Mobile accordion functionality
  const accordionToggles = document.querySelectorAll('.accordion-toggle');

  accordionToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const targetContent = document.getElementById(targetId);
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Close all other accordions
      accordionToggles.forEach(otherToggle => {
        if (otherToggle !== toggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
          const otherId = otherToggle.getAttribute('data-target');
          const otherContent = document.getElementById(otherId);
          otherContent.classList.remove('active');
        }
      });

      // Toggle current accordion
      this.setAttribute('aria-expanded', !isExpanded);
      targetContent.classList.toggle('active');
    });
  });

  // Form submission
  const newsletterForms = document.querySelectorAll('.newsletter-form');

  newsletterForms.forEach(form => {
    // Check URL parameters for form submission results
    function checkForFormStatus() {
      const urlParams = new URLSearchParams(window.location.search);
      const customerPosted = urlParams.get('customer_posted');

      if (customerPosted === 'true') {
        const successMessage = form.querySelector('.newsletter-success');
        if (successMessage) {
          successMessage.style.display = 'block';

          // Hide success message after 5 seconds
          setTimeout(() => {
            successMessage.style.display = 'none';
          }, 5000);
        }
      }
    }

    // Run this check when page loads
    checkForFormStatus();

    form.addEventListener('submit', function(e) {
      const emailInput = this.querySelector('input[type="email"]');
      const privacyCheckbox = this.querySelector('input[type="checkbox"]');
      const errorMessage = this.querySelector('.newsletter-error');

      // Reset any previous error messages
      if (errorMessage) {
        errorMessage.style.display = 'none';
        errorMessage.textContent = '';
      }

      if (!emailInput.value || (privacyCheckbox && !privacyCheckbox.checked)) {
        e.preventDefault();

        if (!emailInput.value) {
          if (errorMessage) {
            errorMessage.textContent = 'Please enter your email';
            errorMessage.style.display = 'block';
          }
          emailInput.focus();
        } else if (privacyCheckbox && !privacyCheckbox.checked) {
          if (errorMessage) {
            errorMessage.textContent = 'Please accept the privacy policy';
            errorMessage.style.display = 'block';
          }
          privacyCheckbox.focus();
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-and-image-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class SustainabilitySlider {
      constructor(container) {
        this.container = container;
        this.slides = this.container.querySelectorAll('.sustainability-slide');
        this.tabs = this.container.querySelectorAll('.sustainability-tab');
        this.sliderElem = this.container.querySelector('.sustainability-slider');
        this.currentIndex = 0;
        this.isDragging = false;
        this.startPos = 0;
        this.currentTranslate = 0;
        this.prevTranslate = 0;
        this.animationID = 0;
        this.autoplayInterval = null;
        this.autoplayEnabled = this.container.dataset.autoplay === 'true';
        this.draggingEnabled = this.container.dataset.dragging === 'true';
        this.autoplayDelay = parseInt(this.container.dataset.autoplayDelay) || 7000;

        this.init();
      }

      init() {
        // Set up tab click events
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.goToSlide(index);
            this.resetAutoplay();
          });
        });

        // Set up swipe and drag functionality for both mobile and desktop
        if (this.draggingEnabled) {
          this.setupDragAndSwipe();
        } else {
          // Still set up basic touch swipe for mobile even if dragging is disabled
          this.setupBasicSwipe();
        }

        // Initialize autoplay if enabled
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }

        // Pause autoplay when user interacts with slider
        this.container.addEventListener('mouseenter', () => this.pauseAutoplay());
        this.container.addEventListener('mouseleave', () => {
          if (this.autoplayEnabled) this.startAutoplay();
        });

        // Adjust slider on window resize
        window.addEventListener('resize', () => this.handleResize());

        // Initial setup
        this.handleResize();
        this.handleVideoAutoplay();
      }

      goToSlide(index) {
        // Validate index
        if (index < 0) {
          index = this.slides.length - 1;
        } else if (index >= this.slides.length) {
          index = 0;
        }

        // Update active classes
        this.slides.forEach(slide => slide.classList.remove('active'));
        this.tabs.forEach(tab => tab.classList.remove('active'));

        this.slides[index].classList.add('active');
        this.tabs[index].classList.add('active');

        // Update current index
        this.currentIndex = index;

        // Handle video autoplay for active slide
        this.handleVideoAutoplay();
      }

      nextSlide() {
        this.goToSlide(this.currentIndex + 1);
      }

      prevSlide() {
        this.goToSlide(this.currentIndex - 1);
      }

      startAutoplay() {
        if (!this.autoplayInterval && this.autoplayEnabled) {
          this.autoplayInterval = setInterval(() => {
            this.nextSlide();
          }, this.autoplayDelay);
        }
      }

      pauseAutoplay() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
          this.autoplayInterval = null;
        }
      }

      resetAutoplay() {
        this.pauseAutoplay();
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      }

      handleVideoAutoplay() {
        // Get all HTML5 video elements (not iframes)
        const allVideos = this.container.querySelectorAll('video.slide-video');

        // Pause all videos
        allVideos.forEach(video => {
          if (typeof video.pause === 'function') {
            video.pause();
          }
        });

        // Play the active slide's video
        const activeSlide = this.slides[this.currentIndex];
        const activeVideo = activeSlide.querySelector('video.slide-video');
        if (activeVideo && typeof activeVideo.play === 'function') {
          activeVideo.play().catch(error => {
            // Silent catch for autoplay restrictions
            console.log('Video autoplay prevented: ' + error);
          });
        }
      }

      setupBasicSwipe() {
        let touchStartX = 0;
        let touchEndX = 0;

        this.container.addEventListener('touchstart', (e) => {
          touchStartX = e.changedTouches[0].screenX;
          this.pauseAutoplay();
        }, { passive: true });

        this.container.addEventListener('touchend', (e) => {
          touchEndX = e.changedTouches[0].screenX;

          const SWIPE_THRESHOLD = 50;
          if (touchStartX - touchEndX > SWIPE_THRESHOLD) {
            // Swipe left
            this.nextSlide();
          } else if (touchEndX - touchStartX > SWIPE_THRESHOLD) {
            // Swipe right
            this.prevSlide();
          }

          if (this.autoplayEnabled) {
            this.startAutoplay();
          }
        }, { passive: true });
      }

      setupDragAndSwipe() {
        // Touch events for mobile
        this.slides.forEach(slide => {
          const touchStart = (e) => {
            this.isDragging = true;
            this.startPos = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            this.pauseAutoplay();

            // Stop click events during drag
            if (e.cancelable) {
              e.preventDefault();
            }
          };

          const touchMove = (e) => {
            if (!this.isDragging) return;

            const currentPosition = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            const moveDistance = currentPosition - this.startPos;

            // If significant drag occurred, prevent click events that may follow
            if (Math.abs(moveDistance) > 20) {
              slide.querySelector('.slide-content-wrapper').style.pointerEvents = 'none';
            }
          };

          const touchEnd = (e) => {
            if (!this.isDragging) return;

            this.isDragging = false;
            const endPos = e.type.includes('mouse') ? e.clientX : e.changedTouches[0].clientX;
            const moveDistance = endPos - this.startPos;

            // Threshold for slide change
            const threshold = window.innerWidth * 0.15; // 15% of screen width

            if (moveDistance < -threshold) {
              this.nextSlide();
            } else if (moveDistance > threshold) {
              this.prevSlide();
            }

            // Re-enable click events with a small delay
            setTimeout(() => {
              const contentWrapper = slide.querySelector('.slide-content-wrapper');
              if (contentWrapper) {
                contentWrapper.style.pointerEvents = '';
              }
            }, 100);

            if (this.autoplayEnabled) {
              this.startAutoplay();
            }
          };

          // Mouse events
          slide.addEventListener('mousedown', touchStart);
          slide.addEventListener('mousemove', touchMove);
          slide.addEventListener('mouseup', touchEnd);
          slide.addEventListener('mouseleave', touchEnd);

          // Touch events
          slide.addEventListener('touchstart', touchStart, { passive: true });
          slide.addEventListener('touchmove', touchMove, { passive: true });
          slide.addEventListener('touchend', touchEnd, { passive: true });

          // Prevent drag behavior messing with zoom effect
          slide.addEventListener('dragstart', (e) => e.preventDefault());
        });
      }

      handleResize() {
        // Adjust tab overflow on smaller screens
        const tabsContainer = this.container.querySelector('.sustainability-tabs');
        if (window.innerWidth < 990) {
          // Center active tab on mobile
          const activeTab = this.container.querySelector('.sustainability-tab.active');
          if (activeTab) {
            const containerWidth = tabsContainer.offsetWidth;
            const tabWidth = activeTab.offsetWidth;
            const tabPosition = activeTab.offsetLeft;

            tabsContainer.scrollLeft = tabPosition - (containerWidth / 2) + (tabWidth / 2);
          }
        } else {
          tabsContainer.scrollLeft = 0;
        }
      }
    }

    // Initialize all sliders on the page
    const sliders = document.querySelectorAll('.sustainability-slider-container');
    sliders.forEach(slider => {
      new SustainabilitySlider(slider);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
